var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            class: _vm.type == 2 ? "modal-mask" : "modal-mask1",
            attrs: { id: "groupModal15" },
            on: { click: _vm.hide }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-dialog-slideout modal-lg",
                staticStyle: { "max-width": "100%" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("div", { staticClass: "modal-content p-2" }, [
                  _c("div", { staticClass: "modal-header px-4 pt-2 pb-0" }, [
                    _c("div", { staticStyle: { width: "100%" } }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-uppercase text-muted pt-1",
                          staticStyle: { color: "#6c757d !important" },
                          attrs: { href: "javascript:void(0);" },
                          on: { click: _vm.hide }
                        },
                        [
                          _c("img", {
                            staticClass: "back_icon mr-2",
                            attrs: {
                              src: require("@/assets/manager/back_button_icon.png")
                            }
                          }),
                          _vm._v("Back")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close float-right",
                          attrs: { type: "button" },
                          on: { click: _vm.hide }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal-body",
                      staticStyle: { "min-height": "700px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal_reps_to_review d-none-" },
                        [
                          _c("div", { staticClass: "row mb-2 mt-3" }, [
                            _c("div", { staticClass: "col-6 pl-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "h3 d-inline mr-2 text-uppercase"
                                },
                                [_vm._v(_vm._s(_vm.menteeShortName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-uppercase btn btn-primary d-none mentee_title_btn"
                                },
                                [_vm._v("Apprentice")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 pr-4 text-right" },
                              [
                                _c("div", { staticClass: "text-muted" }, [
                                  _vm._v("Mentor(s)")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "list-inline" },
                                  _vm._l(_vm.mentorsAssigned, function(
                                    mentorAssigned,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                        staticClass:
                                          "list-inline-item font-weight-bold"
                                      },
                                      [_vm._v(_vm._s(mentorAssigned.name))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "mt-1 mb-3 pl-3 pr-3" }, [
                              _c(
                                "div",
                                { staticClass: "row align-items-end" },
                                _vm._l(
                                  _vm.pathwayStepsData.mentee_pathway_steps,
                                  function(pathwayStep, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "col px-2 text-center" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "text-uppercase mb-1 ",
                                            class:
                                              _vm.activeStep == pathwayStep.id
                                                ? "pw_step_title_active"
                                                : "pw_step_title"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                style:
                                                  _vm.activeStep ==
                                                  pathwayStep.id
                                                    ? "background-color: " +
                                                      _vm.pathwayStepsData
                                                        .mentee_pathway
                                                        .ascentColor +
                                                      ";"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(pathwayStep.stepTitle)
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "progress progress_pathway"
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "progress-bar progress_bar_100",
                                              style:
                                                "width:" +
                                                pathwayStep.percentage_completion +
                                                "%;"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mx-2 mb-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col p-0",
                                staticStyle: {
                                  "font-size": "18px",
                                  "font-weight": "bold",
                                  "border-bottom": "1px solid #CCC"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  Approve Certificate\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mx-2 mb-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-1",
                                staticStyle: { "padding-left": "0px" }
                              },
                              [
                                _c("div", { staticClass: "progress-circle" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.certificates.image,
                                      width: "50px",
                                      height: "50px"
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-7 col-xl-8 pl-3",
                                staticStyle: {
                                  "font-size": "15px",
                                  "padding-top": "12px"
                                }
                              },
                              [
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(_vm._s(_vm.certificates.name))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row align-items-center mb-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-12",
                                  staticStyle: { "padding-right": "15px" }
                                },
                                [
                                  _c("div", { staticClass: "px-2" }, [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-5" }, [
                                        _vm.isPDF == 0
                                          ? _c(
                                              "div",
                                              { staticClass: "dropbox" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.image,
                                                    height: "100px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isPDF == 1
                                          ? _c(
                                              "div",
                                              { staticClass: "dropbox1" },
                                              [
                                                _c("p"),
                                                _c(
                                                  "div",
                                                  { staticClass: "row pr-3" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-2 ",
                                                        staticStyle: {
                                                          "padding-top": "0px",
                                                          "padding-left": "20px"
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            height: "35px",
                                                            src: require("@/assets/manager/Mentor Mentee Upload File.png")
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-8 pt-2"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col p-0",
                                                            staticStyle: {
                                                              "font-size":
                                                                "15px",
                                                              "font-weight":
                                                                "bold"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.orgfileName
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p")
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col text-center",
                                              staticStyle: {
                                                cursor: "pointer",
                                                color: "#00ACEE",
                                                "text-decoration": "underline"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadFunc()
                                                }
                                              }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v("View Certificate")
                                              ])
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-7" }, [
                                        _vm.loading == false
                                          ? _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 text-align-right pt-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          Issued Date: \n                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 text-align-right pt-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(_vm.issued_date) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row pt-1" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-6 text-align-right pt-1"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          Expiration Date: \n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-6 text-align-right pt-1"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(_vm.expiration_date) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row pt-1" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-6 text-align-right pt-1"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          Verification Code: \n                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-6 text-align-right pt-1"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.verification_code
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row pt-1" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 text-align-right pt-1"
                                            },
                                            [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.remarks,
                                                    expression: "remarks"
                                                  }
                                                ],
                                                staticClass:
                                                  "textarea col-xs-12 col-md-12 col-lg-12 padding-lr-5 input-height-25",
                                                staticStyle: { height: "60px" },
                                                attrs: {
                                                  name: "remarks",
                                                  placeholder: "Remarks",
                                                  maxlength: "500"
                                                },
                                                domProps: {
                                                  value: _vm.remarks
                                                },
                                                on: {
                                                  keyup: function($event) {
                                                    return _vm.charCount()
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.remarks =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-align-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "Characters left: " +
                                                      _vm._s(_vm.totalcharacter)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row pt-2 text-align-right"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-12 p-0" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 px-2 px-xl-3 float-right"
                                                  },
                                                  [
                                                    _vm.disable_add == true
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "col-9 float-right btn btn-primary rounded-pill border-0 text-white approve_btn d-block",
                                                            attrs: { href: "#" }
                                                          },
                                                          [_vm._v("Approve")]
                                                        )
                                                      : _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "col-9 float-right btn btn-primary rounded-pill border-0 text-white approve_btn d-block",
                                                            attrs: {
                                                              href: "#"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.onSubmit(
                                                                  "Approved"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Approve")]
                                                        ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "col-7 float-right text-center mr-2 d-block",
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.onSubmit(
                                                              "Denied"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Deny")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" })
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efaf61d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efaf61d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/mentee_approve_certificate.vue
// module id = null
// module chunks = 